"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerBasketItemBundle = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _components = require("../components");
var _context = require("../context");
var _hooks = require("../hooks");
var _BasketItemRoot = require("./BasketItemRoot");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BundleWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  gridArea: 'bundle',
  padding: 0,
  width: '100%'
}));
const CollapseTrigger = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'inline-grid',
  gridTemplateColumns: 'auto 24px',
  gap: theme.spacing(1),
  alignItems: 'center',
  padding: theme.spacing(1, 0),
  width: 'max-content',
  textAlign: 'left',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  lineHeight: theme.typography.body1.lineHeight,
  '&:focus': {
    outline: 'none'
  }
}));
const InnerBasketItemBundle = () => {
  const {
    bundleItems,
    isSmall
  } = (0, _context.useItemContext)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const handleExpandClick = (0, _react.useCallback)(() => {
    setExpanded(!expanded);
  }, [expanded]);
  const bundleData = bundleItems?.map(data => ({
    ...data,
    itemTestId: `${data.testId}-item-${data.code}-${data.type}`,
    basicCataloguePrice: undefined,
    cataloguePrice: undefined,
    points: undefined,
    showBp: false,
    totalPrice: '',
    unitPrice: undefined,
    quantityPickerDisabled: true,
    isBundle: false,
    isBundleItem: true,
    isSmall
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(BundleWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(CollapseTrigger, {
      role: "button",
      tabIndex: 0,
      "aria-expanded": expanded,
      "aria-label": translations.whatsInside,
      onClick: handleExpandClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        children: [translations.whatsInside, " (", bundleItems?.length, ")"]
      }), expanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowUpThin, {
        fontSize: "medium"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
        fontSize: "medium"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Collapse, {
      unmountOnExit: true,
      in: expanded,
      timeout: "auto",
      children: bundleData?.map(itemData => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_context.ItemProvider, {
        value: itemData,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_BasketItemRoot.BasketItemRoot, {
          itemTestId: itemData.itemTestId,
          isBundle: false,
          isBundleItem: itemData.isBundleItem,
          isSmall: itemData.isSmall,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ItemImage, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ItemDescription, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ItemActions, {})]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Separator, {})]
      }, itemData.itemTestId))
    })]
  });
};
exports.InnerBasketItemBundle = InnerBasketItemBundle;
